/* Vintage Paris PDP — gallery + scroll reveal. Scoped to .vp-pdp nodes only. */
(function () {
  var DUR = 200;

  /* ---- Gallery: thumb -> main crossfade ---- */
  var main = document.querySelector('.vp-pdp .vp-main-img');
  var thumbs = Array.prototype.slice.call(
    document.querySelectorAll('.vp-pdp .vp-thumbs .vp-thumb')
  );
  var swapToken = 0;
  function showThumb(thumb) {
    var img = thumb.getAttribute('data-img');
    if (!img || !main) return;
    thumbs.forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
    var token = ++swapToken;
    var started = Date.now();
    main.style.opacity = '0';
    var loader = new Image();
    var swap = function () {
      if (token !== swapToken) return; /* a newer click superseded this one */
      main.style.backgroundImage = "url('" + img + "')";
      main.style.opacity = '1';
    };
    loader.onload = function () {
      /* wait out whatever remains of the fade-out so the crossfade stays smooth */
      var wait = Math.max(0, DUR - (Date.now() - started));
      setTimeout(swap, wait);
    };
    loader.onerror = swap;
    loader.src = img;
  }
  /* warm the cache so first-click swaps are instant */
  if ('requestIdleCallback' in window) {
    requestIdleCallback(function () {
      thumbs.forEach(function (t) {
        var src = t.getAttribute('data-img');
        if (src) { var pre = new Image(); pre.src = src; }
      });
    });
  }
  thumbs.forEach(function (thumb) {
    thumb.setAttribute('tabindex', '0');
    thumb.setAttribute('role', 'button');
    thumb.addEventListener('click', function () { showThumb(thumb); });
    thumb.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); showThumb(thumb); }
    });
  });

  /* ---- Scroll-reveal entrances ---- */
  document.querySelectorAll('.vp-pdp .vp-reveal-stagger').forEach(function (group) {
    Array.prototype.slice.call(group.children).forEach(function (child, i) {
      child.style.setProperty('--i', i);
    });
  });
  var revealEls = document.querySelectorAll('.vp-pdp .vp-reveal, .vp-pdp .vp-reveal-stagger');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('in-view'); });
  }
})();
